import kr from '../kr/kr';

export default class SwipeUp extends kr.Component {
    init() {
        this.swipeToTop();
    }

    swipeToTop() {
        const swipeAngle = document.querySelector('.swipe-up-angle');

        swipeAngle.addEventListener('click', ()=> {
            scrollTo(0, 0);
        })
    }
}

kr.registerComponent('.swipe-up-angle', {
    component: SwipeUp
});